import { containerNames } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';

export class BackgroundDrawer {
  constructor() {
    this.animations = {};
    this.BackgroundContainer = PixiBase.createContainer(containerNames.BackgroundContainer);
  }

  setupBackground() {
    this.background = PixiBase.createSprite(this.spriteSheet.gameBackground);
    this.BackgroundContainer.addChild(this.background);
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.setupBackground();
  }
}
